import React, { useEffect, useState, Fragment } from 'react';
import { Document, Page, PDFViewer, View, Text, Font, StyleSheet } from '@react-pdf/renderer';


import { pageStyle, otpPDFStyle, textStyle, headerStyle, styleQR } from "./styleStudentOtpPdf.js";
import ParentAssessmentQr from './parentAssessmentQr';

import NaanumGothicRegular from "common/fonts/Nanum_Gothic/NanumGothic-Regular.ttf";
import NaanumGothicBold from "common/fonts/Nanum_Gothic/NanumGothic-Bold.ttf";

Font.register({
    family: 'Calibri'
    , fonts: [{ src: "https://github.com/jondot/dotfiles/blob/master/.fonts/calibri.ttf" }
        , { src: "https://github.com/jondot/dotfiles/blob/master/.fonts/calibrib.ttf", fontWeight: "bold" }], format: 'truetype'
});

Font.register({
    family: 'Nanum Gothic',
    fonts: [
        { src: NaanumGothicRegular, fontWeight: 'normal' },
        { src: NaanumGothicBold, fontWeight: 'bold' }
    ]
});
const QrLinkPdf = (props) => {
    const { lstStudent, clsSection, clsId } = props;
    const [schoolId, setSchoolId] = useState(0);
    const [acdYrId, setAcdYrId] = useState(0);
    const [acdYr, setAcdYr] = useState(0);
    const [tchId, setTchId] = useState(0);

    useEffect(() => {
        // console.log("useEffect in QrLinkPdf called, lstStudent", lstStudent);
        setSchoolId(parseInt(localStorage.getItem("schoolId")));
        setAcdYrId(parseInt(localStorage.getItem("academicYearId")));
        setAcdYr(localStorage.getItem("acdYr"));
        // setTchId(parseInt(localStorage.getItem("userId")));
    }, [lstStudent]);

    const students = [];

    const getStudentRow = (pStd1, pStd2, pStd3, pStd4, pStd5, isFirstRow) => {
        // console.log("getStudentRow called, pStd1", pStd1, ", pStd2", pStd2, ", pStd3", pStd3, ", pStd4", pStd4, ", isFirstRow", isFirstRow);
        return (
            <View style={isFirstRow ? otpPDFStyle.firstOtpRow : otpPDFStyle.otpRow}>
                <View style={styleQR.studentCell}>
                    {
                        !!pStd1 ?
                            <View key={pStd1.studentId} style={otpPDFStyle.column}>
                                <View style={styleQR.studentCellColumn}>
                                    <ParentAssessmentQr
                                        schoolId={schoolId}
                                        tchId={tchId}
                                        acdYrId={acdYrId}
                                        studentId={pStd1.studentId}
                                        clsId={clsId}
                                        qrSize={100}
                                    />
                                </View>
                                <View style={styleQR.studentCellColumn}>
                                    <Text style={styles.textLeftSmallBold}>{pStd1.name}</Text>
                                </View>
                                <View style={styleQR.studentCellColumn}>
                                    <Text style={styles.textLeftSmallBold}>{"Roll No: " + pStd1.rollNo}</Text>
                                </View>
                            </View>
                            : null
                    }
                </View>
                <View style={styleQR.studentCell}>
                    {
                        !!pStd2 ?
                            <View key={pStd2.studentId} style={otpPDFStyle.column}>
                                <View style={styleQR.studentCellColumn}>
                                    <ParentAssessmentQr
                                        schoolId={schoolId}
                                        tchId={tchId}
                                        acdYrId={acdYrId}
                                        studentId={pStd2.studentId}
                                        clsId={clsId}
                                        qrSize={100}
                                    />
                                </View>
                                <View style={styleQR.studentCellColumn}>
                                    <Text style={styles.textLeftSmallBold}>{pStd2.name}</Text>
                                </View>
                                <View style={styleQR.studentCellColumn}>
                                    <Text style={styles.textLeftSmallBold}>{"Roll No: " + pStd2.rollNo}</Text>
                                </View>
                            </View>
                            : null
                    }
                </View>
                <View style={styleQR.studentCell}>
                    {
                        !!pStd3 ?
                            <View key={pStd3.studentId} style={otpPDFStyle.column}>
                                <View style={styleQR.studentCellColumn}>
                                    <ParentAssessmentQr
                                        schoolId={schoolId}
                                        tchId={tchId}
                                        acdYrId={acdYrId}
                                        studentId={pStd3.studentId}
                                        clsId={clsId}
                                        qrSize={100}
                                    />
                                </View>
                                <View style={styleQR.studentCellColumn}>
                                    <Text style={styles.textLeftSmallBold}>{pStd3.name}</Text>
                                </View>
                                <View style={styleQR.studentCellColumn}>
                                    <Text style={styles.textLeftSmallBold}>{"Roll No: " + pStd3.rollNo}</Text>
                                </View>
                            </View>
                            : null
                    }
                </View>
                <View style={styleQR.studentCell}>
                    {
                        !!pStd4 ?
                            <View key={pStd4.studentId} style={otpPDFStyle.column}>
                                <View style={styleQR.studentCellColumn}>
                                    <ParentAssessmentQr
                                        schoolId={schoolId}
                                        tchId={tchId}
                                        acdYrId={acdYrId}
                                        studentId={pStd4.studentId}
                                        clsId={clsId}
                                        qrSize={100}
                                    />
                                </View>
                                <View style={styleQR.studentCellColumn}>
                                    <Text style={styles.textLeftSmallBold}>{pStd4.name}</Text>
                                </View>
                                <View style={styleQR.studentCellColumn}>
                                    <Text style={styles.textLeftSmallBold}>{"Roll No: " + pStd4.rollNo}</Text>
                                </View>
                            </View>
                            : null
                    }
                </View>
                <View style={styleQR.studentCell}>
                    {
                        !!pStd5 ?
                            <View key={pStd5.studentId} style={otpPDFStyle.column}>
                                <View style={styleQR.studentCellColumn}>
                                    <ParentAssessmentQr
                                        schoolId={schoolId}
                                        tchId={tchId}
                                        acdYrId={acdYrId}
                                        studentId={pStd5.studentId}
                                        clsId={clsId}
                                        qrSize={100}
                                    />
                                </View>
                                <View style={styleQR.studentCellColumn}>
                                    <Text style={styles.textLeftSmallBold}>{pStd5.name}</Text>
                                </View>
                                <View style={styleQR.studentCellColumn}>
                                    <Text style={styles.textLeftSmallBold}>{"Roll No: " + pStd5.rollNo}</Text>
                                </View>
                            </View>
                            : null
                    }
                </View>
            </View>
        )
    }


    let currentPage = [];
    for (let i = 0; i < lstStudent.length; i += 5) {
        // Create a row with up to 5 students
        const studentRow = getStudentRow(
            lstStudent[i],
            lstStudent[i + 1],
            lstStudent[i + 2],
            lstStudent[i + 3],
            lstStudent[i + 4],
            currentPage.length === 0
        );

        currentPage.push(studentRow);

        // When 5 rows are collected, push the page and reset
        if (currentPage.length === 5 || i + 5 >= lstStudent.length) {
            students.push(currentPage);
            currentPage = [];
        }
    }

    return (
        <div className='col-sm-12 padding-remove' style={{ marginTop: "1vh" }}>
            <PDFViewer style={{ width: "100%", height: "98vh", overflowY: "scroll" }}>
                <Document >
                    {students.map((studentPage, pageIndex) => (
                        <Page key={pageIndex} style={pageStyle.page} wrap>
                            <View style={pageStyle.fullPage}>
                                {
                                    pageIndex === 0 ?
                                        <View style={pageStyle.testHeader} >
                                            <View style={headerStyle.column}>
                                                <View style={headerStyle.row}>
                                                    <View style={headerStyle.viewLeft}>
                                                        <Text style={textStyle.textCenterMediumBold}>{"HPC Parent QR"}</Text>
                                                    </View>
                                                </View>
                                                <View style={headerStyle.row}>
                                                    <View style={headerStyle.leftSection}>
                                                        <View style={headerStyle.viewLeft}>
                                                            <Text style={textStyle.textLeftMediumBold}>
                                                                {clsSection}
                                                            </Text>
                                                        </View>
                                                    </View>
                                                    <View style={headerStyle.rightSection}>
                                                        <View style={headerStyle.viewRight}>
                                                            <Text style={textStyle.textRightMediumBold}>{acdYr}</Text>
                                                        </View>
                                                    </View>
                                                </View>
                                            </View>
                                        </View>
                                        : null
                                }
                                <View style={pageStyle.horizontalBar2} fixed></View>
                                <View style={pageStyle.pageContent}>
                                    {studentPage.map((student, index) => (
                                        <Fragment key={index} >
                                            {student}
                                        </Fragment>
                                    ))}
                                </View>
                            </View>
                        </Page>
                    ))}
                </Document>
            </PDFViewer>
        </div>
    );
}

export default QrLinkPdf;


const styles = StyleSheet.create({

    textLeftSmallBold: {
        fontFamily: 'Nanum Gothic',
        justifyContent: "center",
        textAlign: "left",
        fontWeight: "bold",
        fontSize: 10,
        color: '#000',
        // borderWidth: 1,
        // borderColor: "#000",
    },
});